import React from 'react'
import PropTypes from 'prop-types'
import { constants } from 'common/helpers'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Countdown from 'components/ui/countdown/ActiveQueueCountdown/ActiveQueueCountdown'

import messages from './messages'
import s from './AddPerfumeToQueueCountdown.scss'


const AddPerfumeToQueueCountdown = ({ gender }) => (
  <div data-testid={constants.testIds.thankYouPage.queueCountdownSection}>
    <Box mt="16">
      <Text
        className={s.title}
        color="brand"
        message={messages.brandTitle}
        values={{
          gender,
        }}
        semibold
        uppercase
        html
      />
    </Box>
    <Box className={s.countdown} mt="16" p="8">
      <Text className={s.countdownText} message={messages.only} />
      <Countdown className={s.digits} withColons />
      <Text className={s.countdownText} message={messages.left} />
    </Box>
    <Box mt="16">
      <Text
        className={s.text}
        values={{ gender }}
        message={messages.youHave}
        html
      />
    </Box>
  </div>
)

AddPerfumeToQueueCountdown.propTypes = {
  gender: PropTypes.string.isRequired,
}

export default AddPerfumeToQueueCountdown
